"use client";
import useTranslate from "@app/_hooks/useTranslate";
import { useCheckoutContext } from "./Checkout.hooks";

export default function CheckoutEmpty() {
  const t = useTranslate();
  useCheckoutContext();

  return <p className="px-6 py-8 text-xl">{t("noItemsInCart")}</p>;
}
